export class ProductSticky extends window.BAO.CustomElement() {
  constructor () {
    super()

    window.addEventListener('scroll', calculateHeader.bind(this))

    function calculateHeader () {
      const header = document.querySelector('#header')
      const thisOffset = this.getBoundingClientRect().top
      const calculatedOffset = thisOffset - header.offsetHeight

      if (calculatedOffset <= 0 && thisOffset >= 0) {
        header.style.setProperty('--Sticky_Offset', `${calculatedOffset}px`)
      } else {
        header.style.removeProperty('--Sticky_Offset')
      }
    }
  }
}

customElements.define('product-sticky', ProductSticky)
